import { render, staticRenderFns } from "./HotelDetails.vue?vue&type=template&id=4fcbf194"
import script from "./HotelDetails.vue?vue&type=script&lang=js"
export * from "./HotelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports